module.exports = __webpack_public_path__ + "img/ColoredSpace3.3bd0b4b8.jpg";